/* eslint-disable no-unused-vars */
import bodymovin from 'lottie-web/build/player/lottie_light.min';
import inView from 'in-view';

export default class LottieAnimation {
  constructor() {
    this.selector = '.c-lottie-animation';
    this.loopSelector = '.lottie-animation-simple-loop-trigger';
    this.onceSelector = '.lottie-animation-play-once-in-viewport-trigger';
  }

  bootstrap() {
    // Add data id to lotties
    this.createIds();

    // Load looping lotties
    this.loopingLotties = this.loadLotties(this.loopSelector, {
      loop: true,
      autoplay: true,
    });

    // Load once lotties
    this.playOnScrollLotties = this.loadLotties(this.onceSelector, {
      loop: false,
      autoplay: false,
    });

    this.playLottieOnce(this.onceSelector);
  }

  createIds() {
    const elements = document.querySelectorAll(
      `${this.selector}, ${this.onceSelector}`
    );

    if (!elements) {
      return;
    }

    for (const [ idx, element ] of elements.entries()) {
      element.dataset.id = `lottie-${idx}`;
    }
  }

  loadLotties(selector, options) {
    const loader = document.querySelectorAll(selector);

    return this.loadBMAnimation(loader, options);
  }

  playLottieOnce(selector) {
    const lotties = document.querySelectorAll(this.onceSelector);

    if (!lotties) {
      return;
    }

    inView(this.onceSelector).on('enter', this.playAnimation.bind(this));
    inView.offset(300);
  }

  playAnimation(item) {
    const { id, played } = item.dataset;

    if (played) {
      return;
    }

    this.playOnScrollLotties[id].play();
    // eslint-disable-next-line no-param-reassign
    item.dataset.played = true;
  }

  // eslint-disable-next-line class-methods-use-this
  loadBMAnimation(loader, options) {
    const animation = [];

    for (const element of loader) {
      const { json, id } = element.dataset;

console.log(element);
console.log(json);

      const lottieSettings = {
        ...options,
        renderer: 'svg',
        container: element,
        path: json,
      };

      animation[id] = bodymovin.loadAnimation(lottieSettings);
    }

    return animation;
  }
}
